const requireAll = (requireContext: any) =>
  requireContext.keys().map(requireContext);
const req = require.context("./svg", false, /\.svg$/);

requireAll(req);

// 新增svg 文件需要手动删除颜色，fill="#1296db"
